import moment from 'moment';

export const dateConfig = {
  limit: {
    min: '2015-01-01',
    max: moment().add(3, 'y').format('YYYY-MM-DD'),
  },
  dateFormat: 'YYYY-MM-DD',
  defaultDateInput: 'yyyy-MM-dd',
  defaultDatePipe: 'MM/dd/yyyy',
  dbDateTimeFormat: 'YYYY-MM-DD HH:MM:SS',
};
